import React, { Suspense, lazy } from "react";

import { Switch, Route, Navigate, Redirect } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//Default Layout
import NavigationBar from "./components/NavigationBar";
import Footer from "./components/Footer";

//Routes go here
import Spinner from "./images/loader.gif";

//mostly common stlyes & each component css here
import "./App.scss";
import "./Appnew.css";
import "swiper/swiper.less";
import Faqpage from "./container/Faqpage/Faqpage";
import OurProductsNew from "./container/OurProductsNew/OurProductsNew";
import LandingPage from "./container/LandingPage/LandingPage";
import LandingThankyou from "./container/LandingThankyou/LandingThankyou";
import TermsAndConditions from "./container/TermsAndConditions/TermsAndConditions";
import ContestFloat from "./componentsnew/ContestFloat/ContestFloat";
import Banner from "./container/Diwalipage/Banner/Banner";
import { DiwaliForm } from "./container/Diwalipage/DiwaliForm/DiwaliForm";
import {
  diwali,
  diwali2025,
  diwali2025ParticipateForm,
  diwali2025About,
  diwali2025Gallery,
  diwali2025Thankyou,
  diwali2025TermsandCondition,
  diwali2026,
  diwali2026ParticipateForm,
  diwali2026ParticipateFormV2,
  diwali2026Thankyou,
  diwali2026About,
  diwali2026Gallery,
  diwaliWinners2026,
  diwaliOfficialRules2026,
  diwaliabout,
  diwaliform,
  diwaligallery,
  diwalitermscondition,
  diwalithankyou,
  diwaliwinner,
  diwaliWinners2025,
  megawinners,
  termsandconditions,
  winners,
} from "./helpers/constant-words";
import DiwaliAbout from "./container/Diwalipage/DiwaliAbout/DiwaliAbout";
import DiwaliGallery from "./container/Diwalipage/DiwaliGallery/DiwaliGallery";
import DiwaliThankyou from "./container/Diwalipage/DiwaliThankyou/DiwaliThankyou";

import DiwaliTermsAndConditions from "./container/Diwalipage/DiwaliTermsAndConditions/DiwaliTermsAndConditions";
import Winner from "./container/Diwalipage/Winners/Winners";
import { useHistory } from "react-router-dom";
import MegaWinner from "./container/Diwalipage/MegaWinner/MegaWinner";
import CouponDisplay from "./pages/CouponDisplay";
// import DiwaliBanner from "./container/Diwali2025/DiwaliBanner/DiwaliBanner";
// import RedirectQRCode from "./components/RedirectQRCode";
// import DiwaliParticipateForm from "./container/Diwali2025/DiwaliParticipateForm/DiwaliParticipateForm";
// import DiwaliAboutUs from "./container/Diwali2025/DiwaliAboutUs/DiwaliAboutUs";
// import MegaWinner2025 from "./container/Diwali2025/MegaWinner/MegaWinner";
// import Diwali2025ThankYou from "./container/Diwali2025/DiwaliThankYou/DiwaliThankYou";
// import Diwali2025TermsAndCondition from "./container/Diwali2025/DiwaliTermsandCondition/DiwaliTermsandCondition";
import DiwaliBannerCommingSooon from "./container/Diwali2025/DiwaliBannerCommingSoon/DiwaliBannerCommingSoon";
import DiwaliGalleryListing26 from "./container/Diwali2026/DiwaliGallery26/DiwaliGalleryListing26";
// import DiwaliBannerV2 from "./container/Diwali2025/DiwaliBanner/DiwaliBannerV2";
// import DiwaliGallery25 from "./container/Diwali2025/DiwaliGallery25/DiwaliGallery25";

const DiwaliBanner = lazy(
  () => import("./container/Diwali2025/DiwaliBanner/DiwaliBanner"),
);
const RedirectQRCode = lazy(() => import("./components/RedirectQRCode"));
const DiwaliParticipateForm = lazy(
  () =>
    import("./container/Diwali2025/DiwaliParticipateForm/DiwaliParticipateForm"),
);
const DiwaliParticipateFormV2 = lazy(
  () =>
    import("./container/Diwali2025/DiwaliParticipateForm/DiwaliParticipateFormV2"),
);
const DiwaliAboutUs = lazy(
  () => import("./container/Diwali2025/DiwaliAboutUs/DiwaliAboutUs"),
);
const MegaWinner2025 = lazy(
  () => import("./container/Diwali2025/MegaWinner/MegaWinner"),
);
const Diwali2025ThankYou = lazy(
  () => import("./container/Diwali2025/DiwaliThankYou/DiwaliThankYou"),
);
const Diwali2025TermsAndCondition = lazy(
  () =>
    import("./container/Diwali2025/DiwaliTermsandCondition/DiwaliTermsandCondition"),
);
const DiwaliGallery25 = lazy(
  () => import("./container/Diwali2025/DiwaliGallery25/DiwaliGallery25"),
);

const Diwali2026ParticipateFormComponent = lazy(
  () =>
    import("./container/Diwali2026/DiwaliParticipateForm26/DiwaliParticipateFormV2"),
);
const Diwali2026ParticipateFormComponentV2 = lazy(
  () =>
    import("./container/Diwali2026/DiwaliParticipateForm26V2/DiwaliParticipateFormV2"),
);
const Diwali2026ThankYou = lazy(
  () => import("./container/Diwali2026/DiwaliThankYou/DiwaliThankYou"),
);
const Diwali2026AboutUs = lazy(
  () => import("./container/Diwali2026/DiwaliAboutUs/DiwaliAboutUs"),
);
const DiwaliGallery26 = lazy(
  () => import("./container/Diwali2026/DiwaliGallery26/DiwaliGallery26"),
);
const MegaWinner2026 = lazy(
  () => import("./container/Diwali2026/MegaWinner/MegaWinner"),
);
const MegaWinner2026V2 = lazy(
  () => import("./container/Diwali2026/MegaWinner/MegaWinnerV2"),
);
const DiwaliBanner2026 = lazy(
  () => import("./container/Diwali2026/DiwaliBanner/DiwaliBanner"),
);
const DiwaliOfficialRules2026Component = lazy(
  () =>
    import("./container/Diwali2026/DiwaliOfficialRules/DiwaliOfficialRules"),
);

//Code splitting for performance
const Home = React.lazy(() => import("./pages/Home"));
const NotFound = React.lazy(() => import("./pages/NotFound"));
const OurStory = React.lazy(() => import("./pages/OurStory"));
const OurProducts = React.lazy(() => import("./pages/OurProducts"));
const OurKitchen = React.lazy(() => import("./pages/OurKitchenV2"));
const OurKitchenChef = React.lazy(() => import("./pages/OurKitchenChef"));
const OurStoreLocator = React.lazy(() => import("./pages/OurStoreLocator"));
const Media = React.lazy(() => import("./pages/Media"));
const Contact = React.lazy(() => import("./pages/Contact"));
// const Blog = React.lazy(() => import("./pages/Blog"));
// const BlogCardDetails = React.lazy(() =>
// import("./components/BlogCardDetails")
// );

// ----------------vijay imports start
const Homepage = React.lazy(() => import("./container/Homepage/Homepage"));
const HomepageV2 = React.lazy(() => import("./container/Homepage/HomepageV2"));
const BlogsNew = React.lazy(() => import("./container/BlogsNew/BlogsNew"));
const BlogFullDetail = React.lazy(
  () => import("./container/BlogFullDetail/BlogFullDetail"),
);
// ----------------end of vijay imports start

//Main Component entry for routes
function App() {
  return (
    <div className="App">
      <ToastContainer />
      <Suspense
        fallback={
          <div className="Spinner">
            <img src={Spinner} alt="spinner" loading="lazy" />
          </div>
        }
      >
        <NavigationBar />
        <ContestFloat />
        {/* <ToastContainer> */}
        {/* <ToastContainer> */}
        <Switch>
          {/* <Route exact path="/home" component={Home}></Route> */}
          <Route exact path="/" component={Homepage}></Route>
          {/* <Route exact path="/home-v2" component={HomepageV2}></Route> */}
          <Route exact path="/story" component={OurStory}></Route>
          <Route exact path="/products" component={OurProducts}></Route>
          <Route exact path="/products-new" component={OurProductsNew}></Route>
          <Route exact path="/kitchen" component={OurKitchen}></Route>
          <Route exact path="/kitchen/:chef" component={OurKitchenChef}></Route>
          {/* <Route exact path="/kitchen/category/" component={}></Route> */}
          <Route
            exact
            path="/store-locator"
            component={OurStoreLocator}
          ></Route>
          <Route exact path="/media" component={Media}></Route>
          <Route exact path="/blogs" component={BlogsNew}></Route>
          <Route exact path="/blogs/:title" component={BlogFullDetail}></Route>
          {/* <Route exact path="/blogsold" component={Blog}></Route> */}
          {/* <Route exact path="/blogsold/:id" component={BlogCardDetails}></Route> */}
          <Route exact path="/contact" component={Contact}></Route>
          <Route exact path="/faq" component={Faqpage}></Route>
          <Route
            exact
            path="/50-years-contest"
            // component={LandingPage}
          >
            <Redirect to="/" />
          </Route>
          <Route
            exact
            path="/50-years-contest/thankyou"
            // component={LandingThankyou}
          >
            <Redirect to="/" />
          </Route>
          <Route
            exact
            path={termsandconditions}
            component={TermsAndConditions}
          ></Route>
          <Route exact path={diwali} component={Banner}>
            {/* <Redirect to="/" /> */}
          </Route>
          {/* <Route exact path={diwaliform}>
            <Redirect to={diwaliwinner} />
          </Route> */}
          <Route exact path={diwaliform} component={DiwaliForm}>
            {/* <Redirect to={diwaliwinner} /> */}
          </Route>
          <Route exact path={diwaliabout} component={DiwaliAbout}></Route>
          <Route exact path={diwaligallery} component={DiwaliGallery}></Route>
          <Route exact path={diwalithankyou} component={DiwaliThankyou}></Route>
          {/* <Route exact path={winners} component={Winner}></Route> */}
          <Route exact path={winners} component={MegaWinner}>
            {/* <Redirect to="/" /> */}
          </Route>
          <Route
            exact
            path={diwalitermscondition}
            component={DiwaliTermsAndConditions}
          ></Route>
          {/* <Route exact path="/laxmibonanza" component={CouponDisplay}></Route> */}
          <Route exact path="/laxmibonanza" component={RedirectQRCode}></Route>

          {/* <==================== DIWALI 2025 PAGES START ===================> */}
          <Route exact path={diwali2025} component={DiwaliBanner}>
            {/* <Redirect to="/" /> */}
          </Route>
          {/* <Route
            exact
            path={diwali2025}
            component={DiwaliBannerCommingSooon}
          ></Route> */}

          <Route
            exact
            path={diwali2025ParticipateForm}
            component={DiwaliParticipateFormV2}
          >
            {/* <Redirect to="/" /> */}
          </Route>
          <Route exact path={diwali2025About} component={DiwaliAboutUs}>
            {/* <Redirect to="/" /> */}
          </Route>
          <Route exact path={diwali2025Gallery} component={DiwaliGallery25}>
            {/* <Redirect to="/" /> */}
          </Route>
          <Route exact path={diwaliWinners2025} component={MegaWinner2025}>
            {/* <Redirect to="/" /> */}
          </Route>
          <Route exact path={diwali2025Thankyou} component={Diwali2025ThankYou}>
            {/* <Redirect to="/" /> */}
          </Route>
          <Route
            exact
            path={diwali2025TermsandCondition}
            component={Diwali2025TermsAndCondition}
          >
            {/* <Redirect to="/" /> */}
          </Route>
          {/* <==================== DIWALI 2025 PAGES END ===================> */}

          {/* <==================== DIWALI 2026 PAGES START ===================> */}
          <Route exact path={diwali2026} component={DiwaliBanner2026}></Route>
          {/* <Route
            exact
            path={diwali2026ParticipateForm}
            component={Diwali2026ParticipateFormComponent}
          ></Route> */}
          <Route
            exact
            path={diwali2026ParticipateForm}
            component={Diwali2026ParticipateFormComponentV2}
          ></Route>
          <Route
            exact
            path={diwali2026Thankyou}
            component={Diwali2026ThankYou}
          ></Route>
          <Route
            exact
            path={diwali2026About}
            component={Diwali2026AboutUs}
          ></Route>
          <Route
            exact
            path={diwali2026Gallery}
            component={DiwaliGalleryListing26}
          ></Route>
          <Route
            exact
            path={diwaliWinners2026}
            // component={MegaWinner2026}
            component={MegaWinner2026V2}
          ></Route>
          <Route
            exact
            path={diwaliOfficialRules2026}
            component={DiwaliOfficialRules2026Component}
          ></Route>
          {/* <==================== DIWALI 2026 PAGES END ===================> */}

          <Route exact path="/404" component={NotFound}></Route>
          <Route path="*">
            <Redirect to="/404" />
            <NotFound />
          </Route>
        </Switch>
        {/* </ToastContainer> */}
        <Footer />
      </Suspense>
    </div>
  );
}

export default App;

// https://laxmihos.com/api/homepage/banners done
// https://laxmihos.com/api/homepage/products done
// https://laxmihos.com/api/homepage/laxmi-kitchens done
// https://laxmihos.com/api/homepage/blogs done
// https://laxmihos.com/api/homepage/laxmiworld empty array

// https://laxmihos.com/api/blogs empty
// https://laxmihos.com/api/blogs/banners img dont work fixing

// https://laxmihos.com/api/laxmis-kitchen/recipes done search recipe text
// https://laxmihos.com/api/laxmis-kitchen/banners done

// https://laxmihos.com/api/contactus/banners done
// https://laxmihos.com/api/contactus/details changes need from api

// https://laxmihos.com/api/media/banners done
// https://laxmihos.com/api/media/videos done need change of size

// https://laxmihos.com/api/ourstory/welcome done
// https://laxmihos.com/api/ourstory/visionmission done
// https://laxmihos.com/api/ourstory/milestones only TITLE Milestones not there
// https://laxmihos.com/api/ourstory/banners done

// https://laxmihos.com/api/product/products working
